<div class="slider_container" [ngClass]="{'slider_container--disabled': disabled === true,'slider_container--reversed':reversed === true}">
  <div class="steps_row">
    <div>
        <div *ngFor='let step of steps'>
            <button [attr.aria-disabled]="disabled===true ? true : false"  class="steps_row__step" (click)='onStepClick(step)'
                [ngClass]="{'steps_row__step--active': step.id===actualStep?.id}" tabindex="-1">{{step.label}}</button>
        </div>
    </div>
  </div>
  <div class="slider_row">
    <div #slider role='slider' class="slider" (keydown)="onSliderKeydown($event)">
      <div #thumbnail (mousedown)='onThumbnailPressed($event)' (touchstart)='onThumbnailTouched($event)'
        class="slider__thumbnail noselect">
      </div>
      <div *ngFor='let fragment of steps; let i = index' [attr.aria-label]='fragment.label'  class="slider__fragment"
        [ngClass]="{'slider__fragment--active': isSliderFragmentActive(fragment)}">
        <div (click)='onFragmentClicked($event,fragment)' class="fragment__tick"></div>
        <div *ngIf='i > 0' (click)='onFragmentClicked($event,fragment)' class="fragment__line"></div>
      </div>
    </div>
  </div>
</div>